import { createContext, useContext } from 'react';

interface VoiceInputContextType {
  registerInput: (element: HTMLInputElement | HTMLTextAreaElement) => void;
  unregisterInput: () => void;
  updateCaretPosition: (start: number, end: number) => void;
}

// Create a context that can be optionally provided by smart zone
export const VoiceInputIntegrationContext = createContext<VoiceInputContextType | null>(null);

// Hook to optionally use voice input - returns null if not in smart zone
export const useVoiceInputIntegration = () => {
  return useContext(VoiceInputIntegrationContext);
};
